"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getNameAbbreviation = function getNameAbbreviation(firstName, lastName) {
  return "".concat(firstName, " ").concat((lastName || '').charAt(0), ".");
};

var _default = getNameAbbreviation;
exports["default"] = _default;
//# sourceMappingURL=getNameAbbreviation.js.map